import {makeStyles} from '@mui/styles';

export default makeStyles(theme => ({
  root: {
    margin: 10,
    padding: theme.spacing(3)
  },
  cardRoot: {
    margin: 20,
    display: 'flex',
    minHeight: 300,
  },
  details: {
    display: 'flex',
    flexDirection: 'column',
  },
  cardContent: {
    // flex: '1 0 auto',
    margin: 0,
    overflowWrap: "break-word"
  },
  cover: {
    width: '100%',
    maxWidth: 100,
    height: 'auto'
  },
  controls: {
    display: 'flex',
    alignItems: 'right',
  },
  playIcon: {
    height: 38,
    width: 38,
  },
  content: {
    display: 'flex',
    flexWrap: 'wrap',
    minWidth: 50,
    width: '100%',
  },
  appTitle: {
    fontWeight: 800,
    color: theme.palette.textColor,
    padding: 5
  },
  image: {
    position: 'relative',
    minWidth: 150,
    height: '100%',
    [theme.breakpoints.down('xs')]: {
      width: '100% !important', // Overrides inline-style
      height: 15,
    },
    '&:hover, &$focusVisible': {
      zIndex: 1,
      '& $imageBackdrop': {
        opacity: 0.5,
        filter: `saturate(var(--value, 2))`,
        webkitFilter: `saturate(var(--value, 2))`
      },
      '& $imageMarked': {
        opacity: 0,
      },
      '& $imageTitle': {
        padding: 5,
        border: '5px solid currentColor',
        borderRadius: 10
      },
    },
  },
  focusVisible: {},
  imageButton: {
    position: 'absolute',
    left: 0,
    right: 0,
    top: 0,
    bottom: 0,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    color: theme.palette.common.white,
  },
  captionText: {
    padding: 10
  },
  imageSrc: {
    position: 'absolute',
    left: 0,
    right: 0,
    top: 0,
    bottom: 0,
    backgroundSize: 'cover',
    backgroundPosition: 'center',
  },
  imageBackdrop: {
    position: 'absolute',
    left: 0,
    right: 0,
    top: 0,
    bottom: 0,
    opacity: 0.5,
    transition: theme.transitions.create('opacity'),
  },
  iconImageDiv: {
    width: '100%',
    alignContent: 'center'
  },
  iconText: {
    minWidth: 48,
    fontSize: 48
  },
  iconImageDivReverse: {
    width: '100%',
    alignContent: 'center',
    filter: `invert(1)`,
    webkitFilter: `invert(1)`
  },
  imageTitle: {
    maxWidth: 90,
    position: 'relative',
    padding: 5,
    border: '2px solid white',
    borderRadius: 10
  },
  imageMarked: {
    height: 1,
    width: 40,
    backgroundColor: theme.palette.common.white,
    position: 'absolute',
    bottom: -2,
    left: 'calc(50% - 20px)',
    transition: theme.transitions.create('opacity'),
  },
  cardAction: {
    display: 'block',
    textAlign: 'initial'
  }
}));
